import React, { useContext, useEffect, useState } from 'react';
import {
  Box, Button, CircularProgress, Typography, Dialog,
  DialogTitle, DialogContent
} from '@material-ui/core';
import { useStyles } from '../styles';
import Logo from '../components/Logo';
import { Store } from '../Store';
import { Alert } from '@material-ui/lab';
import { getCheckoutUrl, getUserData } from '../actions';
import Axios from 'axios';
import HomeScreen from './SelectPaymentScreen';
import config, { getParameterByName, merchantCode } from '../util';
import waitImg from '../assets/image/wait.gif';
import successImg from '../assets/image/success.gif';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {
  clearOrder,

} from '../actions';

export default function CompleteOrderScreen(props) {
  const styles = useStyles();
  const { state, dispatch } = useContext(Store);
  let { userInfo } = state.userData;
  const { selectedCurrency, order, newURL } = state;
  const [isOpen, setIsOpen] = useState(false);
  const [newOrderProcessing, setNewOrderProcessing] = useState(true);
  const baseURL = config.baseURL;
  const themeColor = userInfo?.themeColor || '#ffbc01';
  const [receipt, setReceipt] = useState("");
  let { setting } = state.userSetting;

  if (!setting) {
    setting = JSON.parse(localStorage.getItem("userInfo"));
  }

  const customersInfo = sessionStorage.getItem("customerInfo") ? JSON.parse(sessionStorage.getItem("customerInfo")) : "";


  useEffect(() => {
    let sessionId = localStorage.getItem("checkoutSessionId");
    findOrderAndPaymentDetails(sessionId);
    clearOrder(dispatch); // Reset cart on completion
    localStorage.removeItem("splashShown");
  }, [])



  const findOrderAndPaymentDetails = async (sessionId) => {
    try {
      if (localStorage.getItem('finalSummary')) {
        let summary = JSON.parse(localStorage.getItem('finalSummary'));
        //document.getElementById("receipt").href=;
        setReceipt("https://www.clover.com/r/" + summary.order.id);
      }
      let merchantDtl = JSON.parse(localStorage.getItem('userInfo'));
      let subPath = "/api/clover/ecom/payment-order-by-session?merchantCode=";
      Axios.get(`${baseURL}${subPath}${merchantDtl.merchantCode}&sessionId=${sessionId}`).then(res => {
        console.log('order placed successfully!!', res);
        localStorage.setItem('finalSummary', JSON.stringify(res.data));
        setNewOrderProcessing(false);
        document.getElementById('merchant-address').innerHTML = res.data.merchantDtl;
        // document.getElementById("receipt").href="https://www.clover.com/r/"+res.data.order.id;
        setReceipt("https://www.clover.com/r/" + res.data.order.id);
        let saveOrderPath = "/api/clover/ecom/orders";
        console.log('order obj', order);
        if (order) {
          Axios.post(`${baseURL}${saveOrderPath}`, { customerId: (customersInfo.customer.id || customersInfo.customer._id), order: JSON.stringify(order), merchantCode: merchantDtl.merchantCode, sessionId: sessionId });
          clearOrder(dispatch);
        }
        clearOrder(dispatch);
      });
    }
    catch (error) {
      console.log(error);

    }

  }

  // const placeFinalOrderToClover = async () => {
  //   try {
  //     let merchantDtl=JSON.parse(localStorage.getItem('userInfo'));
  //     let finalOrder = JSON.parse(localStorage.getItem('finalOrder'));
  //     let subPath = "/api/clover/ecom/orders?merchantCode=";
  //     Axios.post(`${baseURL}${subPath}${merchantDtl.merchantCode}`,finalOrder).then(res=>{
  //        //history.push("/complete?"+ window.location.href.split('?')[1]);
  //         console.log('order placed successfully!!',res);
  //         setNewOrderProcessing(false);
  //       });
  //   }
  //   catch (error) {
  //     console.log(error);

  //   }
  // }

  // const getStripeCheckout = async (runningOrder) => {
  //   try {


  //     let merchantDtl=JSON.parse(localStorage.getItem('userInfo'));
  //     let subPath = "/api/clover/ecom/orders?merchantCode=";
  //     Axios.post(`${baseURL}${subPath}${merchantDtl.merchantCode}`,runningOrder).then(res=>{
  //        setNewOrderProcessing(false);
  //     });
  //   }
  //   catch (error) {
  //     console.log(error);

  //   }
  // };
  const closeHandler = () => {
    setIsOpen(false);
  };
  return (
    <Box style={{ textAlign: "center", height: "100vh", backgroundColor: setting.themeColor }}>
      {newOrderProcessing && <div style={{ display: "flex", height: "100vh", flexDirection: "column", verticalAlign: "middle", textAlign: "center", justifyContent: 'center' }}>
        <div><CircularProgress color={setting.themeTxtColor} style={{ color: setting.themeTxtColor }} /></div>
        <Typography
          variant="h5"
          style={{
            color: setting.themeTxtColor,
            fontFamily: setting.themePrimaryFontFam
          }}
        >
          Confirming your order, please wait...
        </Typography>
      </div>
      }
      {!newOrderProcessing &&
        <div style={{ display: "flex", height: "100vh", flexDirection: "column", verticalAlign: "middle", textAlign: "center", justifyContent: 'center' }}>
          <div><img src={successImg} style={{ height: "100px", width: "100px", borderRadius: "40px" }} /></div>
          <h2 style={{ color: setting.themeTxtColor, fontFamily: setting.themeSecondaryFontFam }}>Hurrah!! Your order placed, it will be ready in 20 mnts(appx.)...</h2>
          <h1 style={{ color: "#fff", fontFamily: setting.themeSecondaryFontFam }}>Collect your order from:</h1>
          <h2 id="merchant-address" style={{ color: setting.themeTxtColor, fontFamily: setting.themeSecondaryFontFam }}></h2>
          <h3 style={{ color: "#fff", fontFamily: setting.themeSecondaryFontFam }}>Find your receipt here
          </h3>
          <div style={{ width: "100%", height: "auto", textAlign: "center" }}>  <Button
            onClick={() => setIsOpen(true)}
            variant="contained"
            size="large"
            style={{
              backgroundColor: setting.themeTxtColor,
              color: setting.themeColor,
              fontWeight: '700',
              borderRadius: "8px",
              padding: '10px 20px',
              maxWidth: "250px",
              margin: "20px"
            }}
          >
            Show Order Receipt
          </Button>

            <Button
              onClick={() => props.history.push('/order?' + window.location.href.split('?')[1])}
              variant="outlined"
              size="large"
              style={{
                backgroundColor: setting.themeTxtColor,
                color: setting.themeColor,
                fontWeight: '700',
                borderRadius: "8px",
                padding: '10px 20px',
                maxWidth: "250px",
                margin: "20px"
              }}
            >
              Go To Home
            </Button>
          </div>
        </div>

      }

      <Dialog
        open={isOpen}
        onClose={closeHandler}
        fullWidth
        BackdropProps={{
          style: {
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "100vh",
            width: "100%"
          }
        }}
        PaperProps={{
          style: {
            padding: "0px",
            borderRadius: "5px",
            fontFamily: setting.themePrimaryFontFam,
            height: "100vh",
            width: "100%"
          }
        }}

      >
        <DialogTitle style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <ArrowBackIosNewIcon
            style={{ color: setting.themeTxtColor, cursor: "pointer", position: 'absolute', left: '15px' }}
            onClick={closeHandler}
          />
          <span style={{ fontFamily: setting.themePrimaryFontFam, fontSize: "1.2em" }}> Your Order Receipt</span>
        </DialogTitle>
        <DialogContent>
          <div id="receipt">
            <iframe width="100%" height="100vh" src={receipt} />
          </div>

        </DialogContent>
      </Dialog>

    </Box>
  );

}
